export default __webpack_public_path__ + "static/media/info.bab457b2.svg";